import { Turbo } from "@hotwired/turbo-rails"

// Le visite Turbo trattenute mentre una richiesta è in volo (dropzone_controller.js, revisione_bozza_controller.js,
// voci_assistant_controller.js, ask_controller.js). Nell'originale la richiesta continuava anche lasciando la scheda (la
// promessa sopravviveva al componente); qui una visita fermerebbe l'invio di un form (navigator.stop) o staccherebbe il
// controller prima della risposta. Finché la richiesta è in volo ogni visita (o solo quelle che `filtro` accetta) si
// ferma con turbo:before-visit e si ricorda l'ultima; a fine richiesta `rilascia()` la restituisce e `riparti(url)` la
// rifà.
//   const visite = new VisiteTrattenute()
//   visite.trattieni()            // inizio della richiesta (idempotente: una seconda chiamata non azzera l'ultima)
//   visite.lascia()               // la risposta è arrivata: le visite passano, l'ultima trattenuta resta
//   const url = visite.rilascia() // fine: smette di trattenere e restituisce l'ultima visita (o null)
//   if (url) riparti(url)
export class VisiteTrattenute {
  constructor({ filtro = () => true } = {}) {
    this.filtro = filtro
    this.attiva = false
    this.rimandata = null
    this.ferma = (event) => {
      if (!this.attiva || !this.filtro(event.detail.url)) return
      event.preventDefault()
      this.rimandata = event.detail.url
    }
  }

  trattieni() {
    if (this.attiva) return
    this.attiva = true
    this.rimandata = null
    document.addEventListener("turbo:before-visit", this.ferma)
  }

  lascia() {
    this.attiva = false
    document.removeEventListener("turbo:before-visit", this.ferma)
  }

  rilascia() {
    this.lascia()
    const url = this.rimandata
    this.rimandata = null
    return url
  }
}

// turbo:before-visit dà solo l'indirizzo: l'azione della visita trattenuta è persa. Una visita alla stessa pagina
// (stesso percorso, anche con altri parametri: es. readiness_controller che toglie ?ricalcolo con replace) riparte con
// action "replace", la regola di Turbo per riconoscere una rilettura (isPageRefresh: stesso percorso e replace), così la
// pagina si aggiorna con morph e non perde ciò che vi gira (es. il polling della revisione della bozza); le altre
// ripartono come visite normali.
export function riparti(url) {
  const dest = new URL(url, window.location.href)
  if (dest.pathname === window.location.pathname) Turbo.visit(dest.toString(), { action: "replace" })
  else Turbo.visit(dest.toString())
}
